export default __webpack_public_path__ + "static/media/reset_icon.184c3023.svg";